import { render, staticRenderFns } from "./OptionsView.vue?vue&type=template&id=935d58f8&"
import script from "./OptionsView.vue?vue&type=script&lang=js&"
export * from "./OptionsView.vue?vue&type=script&lang=js&"
import style0 from "./OptionsView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports